import "/__w/1/s/BotFramework-WebChat/packages/component/src/Attachment/Text/private/CitationModal.module_built.css";
const classes = {"citation-modal-dialog__header":"wOauhfq_citation-modal-dialog__header","citation-modal-dialog__body":"wOauhfq_citation-modal-dialog__body","citation-modal-dialog":"wOauhfq_citation-modal-dialog"}
export default classes

const _citation_modal_dialog__header0 = classes["citation-modal-dialog__header"]
export { _citation_modal_dialog__header0 as "citation-modal-dialog__header" }

const _citation_modal_dialog__body0 = classes["citation-modal-dialog__body"]
export { _citation_modal_dialog__body0 as "citation-modal-dialog__body" }

const _citation_modal_dialog0 = classes["citation-modal-dialog"]
export { _citation_modal_dialog0 as "citation-modal-dialog" }
